import { Star, Quote, MapPin, Home } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { TESTIMONIALS } from "@/data/properties";

export const Testimonials = () => {
  return (
    <section className="bg-background py-12 sm:py-16" data-testid="testimonials-section">
      <div className="abay-container">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">Loved by Ethiopians everywhere</h2>
          <p className="mt-3 text-muted-foreground">Thousands trust ABAY360 to find, sell and invest in property.</p>
        </div>

        <Carousel opts={{ align: "start", loop: true }} className="mt-8">
          <CarouselContent className="-ml-4">
            {TESTIMONIALS.map((t) => (
              <CarouselItem key={t.name} className="pl-4 sm:basis-1/2 lg:basis-1/3">
                <div
                  data-testid="testimonial-card"
                  className="relative flex h-full flex-col rounded-2xl border border-border bg-card p-6 shadow-[var(--shadow-sm)]"
                >
                  <Quote className="absolute right-5 top-5 h-8 w-8 text-[#1E3A8A]/10" />
                  <div className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star
                        key={i}
                        className={`h-4 w-4 ${i < t.rating ? "fill-[#F59E0B] text-[#F59E0B]" : "text-muted-foreground/30"}`}
                      />
                    ))}
                  </div>
                  <p className="mt-4 flex-1 text-foreground/90">&ldquo;{t.quote}&rdquo;</p>

                  <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-[#1E3A8A] dark:text-[#7AA0FF]" /> {t.city}</span>
                    <span className="flex items-center gap-1"><Home className="h-3.5 w-3.5 text-[#0E9F6E]" /> {t.property}</span>
                  </div>

                  <div className="mt-4 flex items-center gap-3 border-t border-border pt-4">
                    <Avatar>
                      <AvatarImage src={t.avatar} alt={t.name} />
                      <AvatarFallback>{t.name.charAt(0)}</AvatarFallback>
                    </Avatar>
                    <div>
                      <p className="font-semibold text-foreground">{t.name}</p>
                      <p className="text-sm text-muted-foreground">{t.role}</p>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-6 flex items-center gap-2">
            <CarouselPrevious data-testid="testimonials-prev" className="static translate-y-0" />
            <CarouselNext data-testid="testimonials-next" className="static translate-y-0" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
